import { Typography } from "antd";
import React from "react";
import CustomButton from "../../shared/custom-button/custom-button";
import { BUTTON_VARIANTS } from "../../constants/styles";
import CustomImage from "../../shared/custom-image/custom-image";
import "./styles.scss";
import { ARROW_PROFILE_CARD } from "../../constants/svgs";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

interface ProfileCardProps {
  name?: string;
  title?: string;
  imageSrc?: string;
  linkedinUrl?: string;
}

const ProfileCard = ({
  name,
  title,
  imageSrc,
  linkedinUrl,
}: ProfileCardProps) => {
  return (
    <div className="ProfileCard">
      <CustomImage src={imageSrc} alt="profile" className="ProfileCard-image" />
      <div className="ProfileCard-content">
        <div className="ProfileCard-content-title">
          <Title className="ProfileCard-title">{name}</Title>
          {ARROW_PROFILE_CARD}
        </div>
        <Text className="ProfileCard-description">{title}</Text>
      </div>

      <CustomButton
        btnVariant={BUTTON_VARIANTS.TEXT}
        className="ProfileCard-button"
      >
        <a href={linkedinUrl || "#"} target="_blank" rel="noopener noreferrer">
          <Text className="ProfileCard-button-text">Connect</Text>
        </a>
      </CustomButton>
    </div>
  );
};

export default ProfileCard;
